import { DataEntityType } from '@tokeet-frontend/tv3-platform'
import * as lodash from 'lodash'

export enum AttributeFieldType {
  Text = 'string',
  Number = 'number',
  PositiveNumber = 'positive_number',
  Date = 'date',
  Boolean = 'boolean',
}

export const attributeFieldTypes = [
  AttributeFieldType.Text,
  AttributeFieldType.Number,
  AttributeFieldType.PositiveNumber,
  AttributeFieldType.Date,
  AttributeFieldType.Boolean,
]

export interface AttributeFieldDef {
  key: string
  touch: 1717084251
  field_type: AttributeFieldType
  description: string //  "date when party is allowed",
  label: string
  attribute: string // "party_allowed"
}

export interface AttributeDescriptionResponse {
  created: number
  attribute_fields: AttributeFieldDef[]
  pkey: string
  entity_type: DataEntityType
  account: number
  archived: number
}

export interface CreateAttributeDescriptionPayload {
  attribute: string // "party_allowed",
  label: string // "Party allowed",
  field_type: AttributeFieldType // "boolean",
  description: string // "Party allowed at the listing"
}

export function attrDescriptionToDataToken(item: AttributeDescriptionResponse) {
  return lodash.map(item.attribute_fields, (t) => {
    return {
      type: item.entity_type,
      token: `*|${lodash.toUpper(item.entity_type)}_ATTRS:${lodash.snakeCase(t.attribute)}|*`,
      description: t.description || t.label,
    }
  })
}

export function getAttributeInfoFromToken(token: string) {
  const match = /^\*\|([A-Z]+)_ATTRS:(.+)\|\*$/.exec(token.trim())
  if (!match) {
    return null
  }
  return [lodash.toLower(match?.[1]), match?.[2]]
}
